<template>
  <div class="list-empty">
    <img src="@static/images/no_msg.png" />
    <span>{{text||'暂无数据'}}</span>
  </div>
</template>

<script>
export default {
  props:["text"],
  components: {},
  data() {
    return {
    };
  },
  watch: {},
  computed: {},
  created() {
  },
  methods: {
  },
};
</script>
<style lang="scss">
.list-empty {
  height: 400px;
  line-height: 1.5;
  padding: 30px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  color: #999999;
  img {
    width: 290px;
  }
}
</style>